import moment from 'moment';
import { convertValidity } from './monthlyRegistrationHelpers';

export const trimLicensePlate = (arr) => {
  let arrCopy = JSON.parse(JSON.stringify(arr));
  arrCopy.forEach(obj => {
    for (const key in obj) {
      if (key == 'vehicle_no' && obj[key]) {
        obj[key] = obj[key].replace(/\s/g, "").replace(/\\/g, "");
      } 
      if (key == 'alternate_vehicles' && obj[key]?.length) {
        obj[key] = obj[key].map(item => ({...item, vehicle_no: item.vehicle_no?.replace(/\s/g, "").replace(/\\/g, "").toUpperCase()}));
      }
    }
  });
  return arrCopy;
};

export const removeEmptyObjects = (arr) => {
  return arr.filter(item => {
    return Object.values(item).some(value => {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== '' && value !== null && value !== undefined;
    });
  });
};

export const buildIndividualRequest = (state) => {
  const validity = convertValidity(state.individualValidity);
  const individualFields = state.individualFields || {};
  const alternateVehicles = state.alternateVehicles || [];
  const selectedPlan = state.selectedPlan;
  const parkingId = state.parkingId;
  const no_of_spots = state.no_of_spots;
  
  const vehicle_no = individualFields.vehicle_no ? individualFields.vehicle_no.replace(/\s/g, "").replace(/\\/g, "").toUpperCase() : '';
  const vehicle_make = individualFields.vehicle_make || '';
  const vehicle_model = individualFields.vehicle_model || '';
  const vehicle_color = individualFields.vehicle_color || '';
  
  const vehicle_detail = [{
    vehicle_no: vehicle_no,
    vehicle_type: '',
    vehicle_make: vehicle_make,
    vehicle_model: vehicle_model,
    vehicle_color: vehicle_color,
    alternate_vehicles: alternateVehicles.map(alt => ({
      vehicle_no: alt.vehicle_no ? alt.vehicle_no.replace(/\s/g, "").replace(/\\/g, "").toUpperCase() : '',
      vehicle_make: alt.vehicle_make || '',
      vehicle_color: alt.vehicle_color || ''
    }))
  }];
  
  const trimmedVehicleDetail = trimLicensePlate(vehicle_detail);
  
  const request = {
    parking_id: parkingId ? parseInt(parkingId) : '',
    first_name: individualFields.first_name,
    last_name: individualFields.last_name,
    country_code: '+' + individualFields.areaCode,
    contact_number: individualFields.phone1 ? individualFields.phone1.replace(/\s/g, '') : '',
    email: individualFields.email,
    validity_start_time: validity ? validity.start : '',
    validity_end_time: '2030-12-31 23:59:59',
    pass_type: selectedPlan?.pricing_type || '',
    payment_type: 'individual',
    user_info: [{ email: individualFields.email }],
    spot_count: no_of_spots ? parseInt(no_of_spots) : '',
    type: 'individual',
    company_name: '',
    reserve_spot: selectedPlan?.pricing_data?.is_reserve_spot ? false : false,
    vehicle_detail: trimmedVehicleDetail,
    door_number: '',
    unit_number: individualFields.unit_number || ''
  };
  
  return request;
};

export const buildAccountRequest = (state) => {
  const validity = convertValidity(state.accountValidity);
  const accountFields = state.accountFields || {};
  const members = state.members || [];
  const selectedPlan = state.selectedPlan;
  const parkingId = state.parkingId;
  const no_of_spots = state.no_of_spots;
  
  let vehicleDetail = members.map(member => {
    const vehicle_no = member.vehicle_no ? member.vehicle_no.replace(/\s/g, "").replace(/\\/g, "").toUpperCase() : '';
    
    const alternate_vehicles = (member.alternate_vehicles || []).map(alt => {
      const alt_vehicle_no = alt.vehicle_no ? alt.vehicle_no.replace(/\s/g, "").replace(/\\/g, "").toUpperCase() : '';
      return {
        vehicle_no: alt_vehicle_no,
        vehicle_make: alt.vehicle_make || '',
        vehicle_color: alt.vehicle_color || ''
      };
    }).filter(alt => alt.vehicle_no || alt.vehicle_make || alt.vehicle_color);
    
    return {
      alternate_vehicles: alternate_vehicles,
      contact_number: member.phone1 ? member.phone1.replace(/\s/g, '') : '',
      country_code: '+' + member.areaCode,
      email: member.email || '',
      vehicle_make: member.vehicle_make || '',
      vehicle_model: member.vehicle_model || '',
      vehicle_no: vehicle_no,
      vehicle_type: ''
    };
  });
  
  vehicleDetail = removeEmptyObjects(vehicleDetail);
  
  const request = {
    parking_id: parkingId ? parseInt(parkingId) : '',
    first_name: accountFields.first_name,
    last_name: accountFields.last_name,
    country_code: '+' + accountFields.areaCode,
    contact_number: accountFields.phone1 ? accountFields.phone1.replace(/\s/g, '') : '',
    email: accountFields.admin_email,
    validity_start_time: validity ? validity.start : '',
    validity_end_time: '2030-12-31 23:59:59',
    pass_type: selectedPlan?.pricing_type || '',
    payment_type: 'account',
    users_info: vehicleDetail,
    spot_count: no_of_spots ? parseInt(no_of_spots) : '',
    type: 'account',
    information_filled_by: 'account',
    company_name: accountFields.company_name,
    reserve_spot: selectedPlan?.pricing_data?.is_reserve_spot ? false : false,
    unit_number: accountFields.unit_number || ''
  };
  
  return request;
};

export const addTimestampsToAlternateVehicles = (details, type, timeZone) => {
  const currentTime = moment().tz(timeZone).valueOf();
  if (type === 'individual') {
    return details.map(vehicle => {
      if (vehicle.alternate_vehicles) {
        vehicle.alternate_vehicles = vehicle.alternate_vehicles.map(alternateVehicle => ({
          ...alternateVehicle,
          created_at: currentTime,
          updated_at: currentTime
        }));
      }
      return vehicle;
    });
  } else if (type === 'account') {
    return details.map(user => {
      if (user.alternate_vehicles && user.alternate_vehicles.length > 0) {
        user.alternate_vehicles = user.alternate_vehicles.map(alternateVehicle => ({
          ...alternateVehicle,
          created_at: currentTime,
          updated_at: currentTime
        }));
      }
      return user;
    });
  }
  return details;
};

